import _typeof from "@babel/runtime/helpers/typeof";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _construct from "@babel/runtime/helpers/construct";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _createClass from "@babel/runtime/helpers/createClass";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var methodName = context.method, method = delegate.iterator[methodName]; if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel; var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
/* eslint-disable @typescript-eslint/no-non-null-assertion */
/* eslint-disable @typescript-eslint/no-empty-interface */
/* eslint-disable max-lines */
import { appendScript, mapYBBoxToBBox, mapYCoordsToCoords, mapGeoObjectsToYGeoObjects, getClustersOptions, mapBBoxToYBBox, mapCoordsToYCoords } from '../../utils';
import { YBalloon } from '../YBalloon';
import { YControl } from '../YControl';
import { DEFAULT_DINAMIC_MAP_OPTIONS } from '../../constants/ymap';
import { DEFAULT_GEO_OBJECTS_LOAD_DELAY, DEFAULT_MAX_GEO_OBJECTS_PER_LOAD } from '../../constants';
import { YRouteControl } from '../YRouteControl';
import { CUSTOM_CONTROLS } from '../../constants/customControls';

/** Класс-фасад над методами библиотеки яндекс карт */
export var YMap = /*#__PURE__*/_createClass( /** Экземпляры классов реализующих внутренние интерфейсы яндекс карт */

/** Настройки внутренней реализациии карт */

function YMap(_options) {
  var _this = this;
  _classCallCheck(this, YMap);
  _defineProperty(this, "internal", void 0);
  _defineProperty(this, "options", void 0);
  _defineProperty(this, "init", function (apiUrl) {
    _this.load({
      require: DEFAULT_DINAMIC_MAP_OPTIONS,
      successCallback: _this.handleSuccessCallback,
      errorCallback: _this.handleErrorCallback
    }, apiUrl);
  });
  _defineProperty(this, "addBalloon", function (balloon, object) {
    _this.throwInitError();
    new YBalloon().addBalloon({
      balloon: balloon,
      yMap: _this.internal.map,
      yInstance: _this.internal.instance,
      object: object
    });
  });
  _defineProperty(this, "addBalloonWithContainer", function (balloon, object) {
    _this.throwInitError();
    new YBalloon().addBalloonWithContainer({
      balloon: balloon,
      yMap: _this.internal.map,
      yInstance: _this.internal.instance,
      object: object
    });
  });
  _defineProperty(this, "removeBalloon", function () {
    _this.throwInitError();
    if (_this.internal.map.balloon && _this.internal.map.balloon.isOpen()) {
      _this.internal.map.balloon.close(true);
    }
  });
  _defineProperty(this, "addControls", function (controls) {
    _this.throwInitError();
    controls.filter(function (control) {
      return !CUSTOM_CONTROLS.includes(control.type);
    }).forEach(function (control) {
      new YControl().addControl({
        control: control,
        yMap: _this.internal.map,
        yInstance: _this.internal.instance,
        onFullscreenControlClick: _this.onFullscreenControlClick,
        onPanoramaStateChange: _this.onPanoramaStateChange
      });
    });
  });
  _defineProperty(this, "addGeoObjects", function (geoObjects) {
    _this.throwInitError();
    if (!geoObjects.length) {
      return;
    }
    var _this$getGeoObjectsBy = _this.getGeoObjectsByMaxGeoObjectsPerLoad(geoObjects),
      resultGeoObjects = _this$getGeoObjectsBy.resultGeoObjects,
      additionalGeoObjects = _this$getGeoObjectsBy.additionalGeoObjects;
    var objectManager = _this.internal.objectManager;
    objectManager.add(mapGeoObjectsToYGeoObjects(_this.internal.instance, resultGeoObjects));

    // добавляем обработчик добавления новых геообъектов из очереди
    objectManager.objects.events.add('optionschange', _this.handleOptionsChange(additionalGeoObjects));
  });
  _defineProperty(this, "removeGeoObjects", function (geoObjects) {
    _this.throwInitError();
    if (!geoObjects.length) {
      return;
    }
    _this.internal.objectManager.remove(geoObjects.map(function (point) {
      return point.options.id;
    }));
  });
  _defineProperty(this, "removeAllGeoObjects", function () {
    var _this$internal$object;
    _this.throwInitError();
    (_this$internal$object = _this.internal.objectManager) === null || _this$internal$object === void 0 ? void 0 : _this$internal$object.objects.removeAll();
  });
  _defineProperty(this, "redraw", function () {
    _this.throwInitError();
    _this.removeBalloon();
    _this.internal.map.container.fitToViewport();
  });
  _defineProperty(this, "setCenterAndZoom", function (options) {
    _this.throwInitError();
    _this.internal.map.setCenter(options.center, options.zoom, {
      duration: options.duration
    });
  });
  _defineProperty(this, "disableScrollZoom", function () {
    _this.throwInitError();
    _this.internal.map.behaviors.disable('scrollZoom');
  });
  _defineProperty(this, "enableScrollZoom", function () {
    _this.throwInitError();
    _this.internal.map.behaviors.enable('scrollZoom');
  });
  _defineProperty(this, "isScrollZoomEnabled", function () {
    _this.throwInitError();
    return _this.internal.map.behaviors.isEnabled('scrollZoom');
  });
  _defineProperty(this, "getZoom", function () {
    var _this$internal$map;
    return (_this$internal$map = _this.internal.map) === null || _this$internal$map === void 0 ? void 0 : _this$internal$map.getZoom();
  });
  _defineProperty(this, "setZoom", function (zoom) {
    var _this$internal$map2;
    return (_this$internal$map2 = _this.internal.map) === null || _this$internal$map2 === void 0 ? void 0 : _this$internal$map2.setZoom(zoom, {
      duration: 150
    });
  });
  _defineProperty(this, "openRouteControl", function (from, to, routingMode) {
    _this.throwInitError();
    return _this.internal.routeControl.init().then(function () {
      if (from) {
        _this.internal.routeControl.setPointFrom(from.coordinates.lat, from.coordinates.lng, !from.fixed, from.label);
      }
      if (to) {
        _this.internal.routeControl.setPointTo(to.coordinates.lat, to.coordinates.lng, !to.fixed, to.label);
      }
      if (routingMode) {
        _this.internal.routeControl.setRoutingMode(routingMode);
      }
    });
  });
  _defineProperty(this, "closeRouteControl", function () {
    _this.throwInitError();
    _this.internal.routeControl.destroy();
  });
  _defineProperty(this, "getVersion", function () {
    _this.throwInitError();
    return _this.internal.instance.meta.version;
  });
  _defineProperty(this, "filterGeoObjects", function (filter) {
    _this.throwInitError();
    _this.internal.objectManager.setFilter(filter);
  });
  _defineProperty(this, "closePanorama", function () {
    _this.throwInitError();
    _this.internal.map.getPanoramaManager().then(function (panoramaManager) {
      return panoramaManager.closePlayer();
    });
  });
  _defineProperty(this, "getRuler", function () {
    var _this$internal$map3;
    return (_this$internal$map3 = _this.internal.map) === null || _this$internal$map3 === void 0 ? void 0 : _this$internal$map3.behaviors.get('ruler');
  });
  _defineProperty(this, "getRestrictMapArea", function (restrictMapArea) {
    if (!restrictMapArea) {
      return {};
    }
    return {
      restrictMapArea: mapBBoxToYBBox(restrictMapArea)
    };
  });
  _defineProperty(this, "getGeoObjectsByMaxGeoObjectsPerLoad", function (points) {
    var _this$options$maxGeoO = _this.options.maxGeoObjectsPerLoad,
      maxGeoObjectsPerLoad = _this$options$maxGeoO === void 0 ? DEFAULT_MAX_GEO_OBJECTS_PER_LOAD : _this$options$maxGeoO;
    var resultPoints = points;
    var additionalPoints = [];
    if (resultPoints.length > maxGeoObjectsPerLoad) {
      resultPoints = points.slice(0, maxGeoObjectsPerLoad);
      additionalPoints = points.slice(maxGeoObjectsPerLoad);
    }
    return {
      resultGeoObjects: resultPoints,
      additionalGeoObjects: additionalPoints
    };
  });
  _defineProperty(this, "getGeoObjectsFetchData", function () {
    var state = _this.internal.map.action.getCurrentState();
    var zoom = state.zoom;
    var bounds = _this.internal.map.getBounds();
    var YCenter = _this.internal.map.getCenter();
    var center = mapYCoordsToCoords(YCenter);
    var bbox = mapYBBoxToBBox(bounds);
    return {
      zoom: zoom,
      center: center,
      bbox: bbox
    };
  });
  _defineProperty(this, "getMapData", function () {
    var _this$options = _this.options,
      center = _this$options.center,
      zoomRange = _this$options.zoomRange,
      defaultZoom = _this$options.defaultZoom,
      container = _this$options.container,
      restrictMapArea = _this$options.restrictMapArea;
    return [container.current, {
      center: mapCoordsToYCoords(center),
      zoom: defaultZoom,
      type: 'yandex#map'
    }, _objectSpread(_objectSpread({}, _this.getRestrictMapArea(restrictMapArea)), {}, {
      minZoom: zoomRange.min,
      maxZoom: zoomRange.max,
      searchControlProvider: 'yandex#search'
    })];
  });
  _defineProperty(this, "handleActionEnd", function () {
    _this.options.onActionEnd(_this.getGeoObjectsFetchData());
  });
  _defineProperty(this, "onFullscreenControlClick", function (state) {
    if (state) {
      _this.handleFullscreenEnter();
    } else {
      _this.handleFullscreenExit();
    }
  });
  _defineProperty(this, "onPanoramaStateChange", function (status) {
    _this.options.onPanoramaStateChange(status);
  });
  _defineProperty(this, "handleFullscreenExit", function () {
    if (_this.options.disableScrollZoom) {
      _this.disableScrollZoom();
    }
    _this.options.onFullscreenStateChange(false);
  });
  _defineProperty(this, "handleFullscreenEnter", function () {
    if (!_this.isScrollZoomEnabled()) {
      _this.enableScrollZoom();
    }
    _this.options.onFullscreenStateChange(true);
  });
  _defineProperty(this, "handleActionTick", function () {
    if (!_this.options.onMove) {
      return;
    }
    _this.options.onMove(_this.getGeoObjectsFetchData());
  });
  _defineProperty(this, "handleSuccessCallback", function (instance) {
    _this.internal.instance = instance;
    require('../../vendor/round');
    var map = _construct(instance.Map, _toConsumableArray(_this.getMapData()));
    _this.internal.map = map;
    _this.handleActionEnd();
    map.events.add('actionend', _this.handleActionEnd);
    map.events.add('actiontick', _this.handleActionTick);
    var yClustersOptions = getClustersOptions(_this.options.clustersOptions);
    var objectManager = new instance.ObjectManager(yClustersOptions);
    _this.internal.objectManager = objectManager;
    map.geoObjects.add(objectManager);
    objectManager.objects.events.add('click', _this.handleGeoObjectClick(objectManager));
    var balloon = _this.internal.map.balloon;
    balloon.events.add('open', _this.handleBalloonOpen(balloon));
    balloon.events.add('userclose', _this.handleBalloonClose(balloon));
    var routeControl = new YRouteControl(map, instance, {
      onActiveRouteChange: _this.options.onActiveRouteChange,
      onRoutesUpdate: _this.options.onRouteBuildingSuccess,
      onRequestSend: _this.options.onRouteBuildingInit,
      onInit: _this.options.onRoutingStart,
      onDestroy: _this.options.onRoutingEnd
    });
    _this.internal.routeControl = routeControl;
    _this.options.successCallback();
  });
  _defineProperty(this, "handleOptionsChange", function (points) {
    return function () {
      var _this$options$geoObje = _this.options.geoObjectsLoadDelay,
        geoObjectsLoadDelay = _this$options$geoObje === void 0 ? DEFAULT_GEO_OBJECTS_LOAD_DELAY : _this$options$geoObje;
      setTimeout(function () {
        return _this.addGeoObjects(points);
      }, geoObjectsLoadDelay);
    };
  });
  _defineProperty(this, "handleErrorCallback", function () {
    _this.options.errorCallback();
  });
  _defineProperty(this, "handleGeoObjectClick", function (objectManager) {
    return /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(e) {
        var objectId, _objectManager$object, geometry, options, properties, geoObject;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              objectId = e.get('objectId');
              _objectManager$object = objectManager.objects.getById(objectId), geometry = _objectManager$object.geometry, options = _objectManager$object.options, properties = _objectManager$object.properties;
              geoObject = {
                type: geometry.type,
                name: properties.name,
                options: properties.options
              }; // Оставляю тут способ получать html pointa
              // const pointId = getMapPointId(object.id); const element = document.getElementById(pointId);
              _context.t0 = geometry.type;
              _context.next = _context.t0 === 'Point' ? 6 : _context.t0 === 'LineString' ? 8 : _context.t0 === 'Polygon' ? 10 : 10;
              break;
            case 6:
              _this.options.onGeoObjectClick(geoObject, {
                offset: [0, options.iconOffset[1]],
                coordinates: geometry.coordinates
              });
              return _context.abrupt("break", 11);
            case 8:
              _this.options.onGeoObjectClick(geoObject, {
                offset: [0, -8],
                coordinates: e.get('coords')
              });
              return _context.abrupt("break", 11);
            case 10:
              return _context.abrupt("return");
            case 11:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }();
  });
  _defineProperty(this, "handleBalloonOpen", function (balloon) {
    return function () {
      var objectManager = _this.internal.objectManager;
      var options = balloon.getOptions();
      var objectId = options.get('targetObjectId');
      var _objectManager$object2 = objectManager.objects.getById(objectId),
        geometry = _objectManager$object2.geometry,
        properties = _objectManager$object2.properties;
      var onBalloonOpen = _this.options.onBalloonOpen;
      if (onBalloonOpen) {
        onBalloonOpen({
          type: geometry.type,
          name: properties.name,
          options: properties.options
        });
      }
    };
  });
  _defineProperty(this, "handleBalloonClose", function (balloon) {
    return function () {
      var onBalloonClose = _this.options.onBalloonClose;
      var options = balloon.getOptions();
      var objectManager = _this.internal.objectManager;
      var objectId = options.get('targetObjectId');
      if (objectId && onBalloonClose) {
        var _objectManager$object3 = objectManager.objects.getById(objectId),
          geometry = _objectManager$object3.geometry,
          properties = _objectManager$object3.properties;
        onBalloonClose({
          type: geometry.type,
          name: properties.name,
          options: properties.options
        });
      }
    };
  });
  _defineProperty(this, "throwInitError", function () {
    if (!_this.internal.map) {
      throw new Error('Карта не инициализирована! Необходимо вызвать метод init');
    }
  });
  _defineProperty(this, "load", /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(options, apiUrl) {
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            if (!_this.internal.ymapsPromise) {
              _context2.next = 2;
              break;
            }
            return _context2.abrupt("return", _this.internal.ymapsPromise);
          case 2:
            if (!window.ymaps) {
              _context2.next = 5;
              break;
            }
            if (options.require && options.require.length) {
              window.ymaps.modules.require(options.require, function () {
                _this.handleSuccessCallback(window.ymaps);
              });
            }
            return _context2.abrupt("return", Promise.resolve(window.ymaps));
          case 5:
            _this.internal.ymapsPromise = new Promise(function (resolve, reject) {
              appendScript({
                apiUrl: apiUrl,
                onload: function onload() {
                  resolve(window.ymaps);
                },
                onerror: function onerror() {
                  options.errorCallback();
                  reject(new Error('Невозможно загрузить Yandex Maps API'));
                }
              });
            });
            return _context2.abrupt("return", _this.internal.ymapsPromise.then(function (ymaps) {
              return ymaps.ready(options);
            }));
          case 7:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function (_x2, _x3) {
      return _ref2.apply(this, arguments);
    };
  }());
  this.options = _options;
  this.internal = {};
}

/** Метод инициализации карт. Все остальные методы возвращают ошибку,
 *  пока этот метод не вызван и не сработал successCallback */);